import Detail from './detail';
import styles from './index.module.scss';

export default function ExampleProductA() {
    return (
        <div className={styles.page}>
            <Detail />
        </div>
    );
}
